export default function (value) {
  return value.substr(0, value.lastIndexOf('.'))
}
